import { KendoBaseComponent } from '@progress/kendo-base-components-vue-wrapper'
import UploadProps from './UploadProps'

import Async from './Async'
import Files from './Files'
import Localization from './Localization'
import Validation from './Validation'

export default {
    props: UploadProps,
    template: '<input type="file"/>',
    mixins: [
        KendoBaseComponent,
        Async,
        Files,
        Localization,
        Validation
    ],
    mounted() {
        kendo.jQuery(this.$el).kendoUpload(this.widgetOptions)

        this.$emit('kendowidgetready', this.kendoWidget())
    },
    methods: {
        kendoWidget() {
            return kendo.jQuery(this.$el).getKendoUpload()
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-upload-vue-wrapper/src/KendoUpload/KendoUploadMixin.js